// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"styles_toolbar__3Rri9","spacer":"styles_spacer__1-rwx"};